import React from "react";

interface ResultDisplayProps {
  resultCol: string[];
}

const ResultDisplay = ({ resultCol }: ResultDisplayProps) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "repeat(5, 1fr)",
        boxSizing: "border-box",
        rowGap: "5px",
      }}
    >
      {resultCol.map((result) => (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(1, 1fr)",
            boxSizing: "border-box",
            columnGap: "5px",
          }}
        >
          <div
            style={{
              padding: "5px",
              border: "solid",
            }}
          >
            {result}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResultDisplay;
